export default "__VITE_PUBLIC_ASSET__8a4da8c2__"